export default {
  "FabricList": {
    'Akita-brown-navy-check': 300,
    'Blitar-blue-check': 300,
    'Makassar-black': 300,
  },
  "ButtonList": {
    'A7455-558': 152,
    'SG2-1953': 152,
    '11018': 132,

  }
}